import { render, staticRenderFns } from "./CustSupport.vue?vue&type=template&id=0a514fa6&"
import script from "./CustSupport.vue?vue&type=script&lang=js&"
export * from "./CustSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports